// Valutes.key НЕ уникален в БД — десятки строк с key:"RUB" (по одной на
// банк/способ оплаты у публичного обменника), плюс дубли, у которых даже
// course реально расходится (USDT: "Tether USD BEP20" ~79.79 vs "Tether USD
// TRC20" 85). Для любого места, где нужна ровно одна запись на валюту
// (селекты, кросс-курсы), дедуплицируем по key — TRC20 выбрана канонической
// для USDT осознанно; у остальных дублей курс совпадает, так что выбор
// первой попавшейся не имеет значения.
export function dedupeValutesByKey(valutes) {
  const counts = {};
  for (const v of valutes) counts[v.key] = (counts[v.key] || 0) + 1;

  const isTrc20 = v => /trc-?20/i.test(v.title || "");
  const byKey = new Map();
  for (const v of valutes) {
    const existing = byKey.get(v.key);
    if (!existing || (!isTrc20(existing) && isTrc20(v))) {
      byKey.set(v.key, v);
    }
  }
  return [...byKey.values()].map(v => ({
    ...v,
    displayLabel: counts[v.key] > 1 ? `${v.key} (${v.title})` : v.key
  }));
}



// WEBPACK FOOTER //
// ./src/utils/valutes.js